"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _CheckCircleOutline = _interopRequireDefault(require("@material-ui/icons/CheckCircleOutline"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function SttSuccessButton() {
  return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    color: "primary",
    disableRipple: true,
    size: "small"
  }, /*#__PURE__*/_react["default"].createElement(_CheckCircleOutline["default"], null));
}
var _default = SttSuccessButton;
exports["default"] = _default;